// extracted by mini-css-extract-plugin
export default {"picker":"components-settings-currency-conversion-multiple-selection-currency-picker-module__picker"};